import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect, useContext } from "react";
import { unByKey } from "ol/Observable";
import { MapContext } from "./MapProvider";
const OlMap = (props) => {
    const { children, zoom, center, height = "100%", width = "100%", onSingleClick } = props;
    const mapRef = useRef(null);
    const map = useContext(MapContext);
    // on component mount
    useEffect(() => {
        if (!map)
            return;
        map.setTarget(mapRef.current);
        return () => {
            map.setTarget(undefined);
        };
    }, [map]);
    // zoom change handler
    useEffect(() => {
        if (!map)
            return;
        if (zoom !== undefined)
            map.getView().setZoom(zoom); //TODO: needs to be updated
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zoom]);
    // center change handler
    useEffect(() => {
        if (!map)
            return;
        map.getView().setCenter(center);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [center]);
    useEffect(() => {
        if (!(map && mapRef.current))
            return;
        const resizeObserver = new ResizeObserver(() => {
            map.updateSize();
        });
        resizeObserver.observe(mapRef.current);
        return () => {
            resizeObserver.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (!map)
            return;
        const key = map.on("singleclick", function (e) {
            if (onSingleClick) {
                onSingleClick(e);
            }
        });
        return () => {
            unByKey(key);
        };
    }, [map, onSingleClick]);
    return (_jsx("div", { ref: mapRef, className: "ol-map", style: { height, width }, children: children }));
};
export default OlMap;
